export const csvRowOffset = (row: number) => row + 1;
